export const WARRANTIES_STATUS = [
    { label: "All statuses", value: "" },
    { label: "PendingPayment", value: 4 },
    { label: "PaymentCompleted", value: 5 },
    { label: "Submitted", value: 6 },
    { label: "PendingIssuance", value: 7 },
    { label: "Issued", value: 8 },
    { label: "Printed", value: 9 },
    { label: "Emailed", value: 16 },
];

export const COUNTRIES = [
    { label: "Select Country", value: "" },
    { label: "United State of America", value: "USA" },
    { label: "Canada", value: "CAN" },
];

